import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import StaticFunctions from "../../utils/StaticFunctions";
import SearchField from "../../utils/SearchField";
import InputField from "../../utils/InputField";
import TextAreaField from "../../utils/TextAreaField";
import Timeformat from "../../utils/Timeformat";
import TableContainer from "../../utils/TableContainer";

class OperatorTokenEditContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        operatorToken: PropTypes.object.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            currentCompany: this.props.baseData.companies.currentCompany,
            tableData: [],
            sortedTableData: [],
            inputParams: props.operatorToken,
        };

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

        this.requestCompanyOperatorsTokenHistory = this.requestCompanyOperatorsTokenHistory.bind(this);
        this.saveEditOperatorToken = this.saveEditOperatorToken.bind(this);
        this.getInput = this.getInput.bind(this);
        this.editSelect = this.editSelect.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onCancel = this.onCancel.bind(this);

    }

    componentWillMount() {

        this.requestCompanyOperatorsTokenHistory();

    }

    componentWillReceiveProps(nextProps) {

        this.setState({
            currentCompany: nextProps.baseData.companies.currentCompany
        }, this.requestCompanyOperatorsTokenHistory);

    }

    requestCompanyOperatorsTokenHistory() {

        if (!this.props.operatorToken) return null;

        const params = {
            action: 'getCompanyOperatorTokenHistory',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            tokenId: this.props.operatorToken.id_token,
            companyId: this.state.currentCompany.id,
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    tableData: res,
                    sortedTableData: res,
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    enterSaveEditOperator(event) {

        if (event.keyCode === 13) {
            this.saveEditOperatorToken();
        } else if (event.keyCode === 27) {
            this.changeView();
        }

    }

    saveEditOperatorToken() {

        if (!this.state.inputParams) return null;

        const params = {
            action: 'saveCompanyOperatorToken',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            tokenId: this.state.inputParams.id_token,
            companyId: this.state.currentCompany.id,
            name: (this.state.inputParams.token_name) ? this.state.inputParams.token_name : null,
            info: (this.state.inputParams.token_info) ? this.state.inputParams.token_info : null,
        };

        const callback = function(res) {
            if (res.success) {
                alert(this.translate(res.msgKey));

                this.props.changeView('editView');
            } else {
                this.setInputError(res.errors);
            }
        }.bind(this);

        if (params.tokenId && params.companyId !== null) {
            this.api.request('AdminFunctions', params, callback, null);
        } else {
            if (!params.tokenId) this.setInputError('id_token');
            if (params.companyId === null) this.setInputError('id_company');
        }

    }

    changeView() {

        if (this.props.changeView) this.props.changeView();

    }

    getInput(event, name, value, isValid) {

        const inputParams = {...this.state.inputParams};

        inputParams[name] = (isValid) ? value : '';

        this.setState({inputParams});

    }

    editSelect(event, key) {

        const inputParams = {...this.state.inputParams};

        inputParams[key] = (event) ? event.value : null;

        this.setState({
            inputParams: inputParams
        });

    }

    setInputError(errorFields) {

        this.setState({
            inputError: errorFields,
        });

    }

    resetInputError() {

        this.setState({
            inputError: [],
        });

    }

    onSearch(value) {

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const format = this.timeFormats.datetime;
        const searchFields = ['operator_name'];
        const companyName = this.props.baseData.companies.currentCompany.name;
        const rows = this.state.tableData || [];
        const filteredRows = [];

        rows.some(
            (row) => {
                let addToResult = false;
                let last_seen = (row.last_seen) ? Timeformat.fromUnix(row.last_seen).getFormatedDate(format, timezone) : '';
                let date_start = (row.date_start) ? Timeformat.fromUnix(row.date_start).getFormatedDate(format, timezone) : '';
                let date_end = (row.date_end) ? Timeformat.fromUnix(row.date_end).getFormatedDate(format, timezone) : '';
                let last_modified = (row.last_modified) ? Timeformat.fromUnix(row.last_modified).getFormatedDate(format, timezone) : '';
                let date_created = (row.date_created) ? Timeformat.fromUnix(row.date_created).getFormatedDate(format, timezone) : '';
                let date_deleted = (row.date_deleted) ? Timeformat.fromUnix(row.date_deleted).getFormatedDate(format, timezone) : '';

                if (companyName && StaticFunctions.substringExists(companyName, value)) {
                    addToResult = true;
                } else if (last_seen && StaticFunctions.substringExists(last_seen, value)) {
                    addToResult = true;
                } else if (date_start && StaticFunctions.substringExists(date_start, value)) {
                    addToResult = true;
                } else if (date_end && StaticFunctions.substringExists(date_end, value)) {
                    addToResult = true;
                } else if (last_modified && StaticFunctions.substringExists(last_modified, value)) {
                    addToResult = true;
                } else if (date_created && StaticFunctions.substringExists(date_created, value)) {
                    addToResult = true;
                } else if (date_deleted && StaticFunctions.substringExists(date_deleted, value)) {
                    addToResult = true;
                } else {
                    searchFields.forEach(
                        (searchField) => {
                            if (row[searchField] && StaticFunctions.substringExists(row[searchField], value)) addToResult = true;
                        }
                    );
                }

                if (addToResult) filteredRows.push(row);
            }
        );

        this.setState({
            sortedTableData: filteredRows
        });

    }

    onCancel() {

        this.setState({
            filteredCompanyOperators: this.state.currentCompanyOperators,
        });

    }

    getCompanyOperatorColumns() {

        return [
            {
                key: 'operator',
                nameKey: 'operator',
                sortType: 'string',
            },
            {
                key: 'dateStartToken',
                nameKey: 'tokenValidFrom',
                sortType: 'datetime',
            },
            {
                key: 'dateEndToken',
                nameKey: 'tokenValidTill',
                sortType: 'datetime',
            },
        ];

    }

    getCompanyOperatorRows() {

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const format = this.timeFormats.datetime;
        const data = (this.state.sortedTableData) ? this.state.sortedTableData : [];
        const rows = [];

        for (let i = 0; i < data.length; i++) {
            let rowTemp = data[i];
            let dateStart = (rowTemp.date_start) ? Timeformat.fromUnix(rowTemp.date_start).getFormatedDate(format, timezone) : '-';
            let dateEnd = (rowTemp.date_end) ? Timeformat.fromUnix(rowTemp.date_end).getFormatedDate(format, timezone) : '-';

            rows.push({
                id: rowTemp.id_token,
                operator: rowTemp.operator_name,
                dateStartToken: dateStart,
                dateEndToken: dateEnd,
            });
        }

        return rows;

    }

    render() {

        if (!this.props.operatorToken) return <LoadingSplash />;

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const format = this.timeFormats.datetime;
        const inputParams = this.state.inputParams;
        const dateCreated = (inputParams.date_created) ? Timeformat.fromUnix(inputParams.date_created).getFormatedDate(format, timezone) : '-';
        const tableColumns = this.getCompanyOperatorColumns();
        const tableRows = this.getCompanyOperatorRows();

        return (
            <div className="formSettings">
                <div className="ma-bo-20 clearfix">
                    <nav>
                        <h1>{this.translate('operatorTokenSettings')}</h1>
                    </nav>

                    <div className="col-lg-4">
                        <div className="formRow">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('token')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="id_token"
                                                value={inputParams.id_token}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('tokenName')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="token_name"
                                                value={inputParams.token_name}
                                                onBlur={this.getInput}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('tokenInfo')}</td>

                                        <td className="text-left">
                                            <TextAreaField
                                                name="token_info"
                                                value={inputParams.token_info}
                                                onBlur={this.getInput}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('tokenRegisterOn')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="date_created"
                                                value={dateCreated}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan webElement">&nbsp;</td>

                                        <td className="text-left">
                                            <a className="formButton" onClick={() => this.props.changeView('editView')}>
                                                {this.translate('cancel')}
                                            </a>

                                            <a className="formButton" onClick={() => this.saveEditOperatorToken()} onKeyDown={(event) => this.enterSaveEditOperator(event)}>
                                                {this.translate('save')}
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="ma-bo-20 clearfix">
                    <div>
                        <nav>
                            <h1>{this.translate('history')}</h1>

                            <SearchField
                                baseData={this.props.baseData}
                                name="searchOperatorTokenEdit"
                                placeholder={this.translate('searching')}
                                styles={{padding: 0}}
                                onSearch={this.onSearch}
                                onCancel={this.onCancel}
                            />
                        </nav>

                        <div className="col-lg-12">
                            <TableContainer
                                baseData={this.props.baseData}
                                columns={tableColumns}
                                rows={tableRows}
                                fillGaps="-"
                            />
                        </div>
                    </div>
                </div>
            </div>
        );

    }

}

export default OperatorTokenEditContainer;
